/*
 * @Author: thl
 * @Date: 2023-11-03 15:48:56
 * @LastEditors: yyz
 * @LastEditTime: 2025-12-03 14:33:40
 */
// 本地环境配置
module.exports = {
  env: 'test',
  corpId: 'wwce03f97db3c60070',
  AgentId: '1000065',
  //T 环境-应用ID
  Secret: '527266a46c2e2513f23e4394d21925ac',
  LOGIN_SECRET: '5f90d0d3e8c9ee49ba09f0e1595b89ed',
  yxwlSysCode: 'crisps-materiel-b-node',
  //营销物料
  yxwlScrect: '90bd0fc13d48d2d6c7acc8c6460ed2ab',
  //营销物料
  title: 'SCRM',
  baseUrl: '',
  pcBaseApi: 'https://tspmicrouag.shupian.cn/',
  //pc中间层
  baseApi: 'https://tspmicrouag.shupian.cn/crm-middle-scrm/',
  // -中间层-本地api请求地址,注意：如果你使用了代理，请设置成'/'
  initApi: 'https://tspmicrouag.shupian.net/crm-middle-scrm/',
  //自建应用需要使用.net后缀域名
  authApi: 'https://tspmicrouag.shupian.cn/crisps-auth-center-api-v2/',
  //鉴权地址-请求商户中心登录信息
  sysCode: 'crisps-crm',
  LOGIN_SYS_CODE: 'crisps-sys',
  addressUrl: 'https://tm-crm.shupian.net/',
  //不同环境的域名
  appDownloadUrl: 'https://tm.shupian.cn/',
  //不同环境的域名
  uploadUrl: 'http://xgxg.shupian.cn/',
  //不同环境的域名
  deleteUrl: 'https://tspmicrouag.shupian.cn/',
  //不同环境的域名
  $cdn: '',
  buriedEnv: 'T',
  //埋点对应环境
  buriedScrect: 'eba20289da7563542b77c5b0717771e1',
  //埋点对应screct
  authUrl: 'https://tm-crm.shupian.net',
  contractShareUrl: 'https://tm.shupian.cn/',
  //0802新增合同分享跳转地址
  wxAppId: 'wxf79340c79c71e3f0',
  //C端-微信小程序id，
  mpAppId: 'wx73d2f2d92b0e429b',
  //B端-智能名片小程序id
  newWxAppId: 'wx86e7431e54630d73',
  //顶呱呱微信小程序id
  yxwlAddressShareUrl: 'https://ttool.dgg.cn/',
  //营销物料模块-分享h5地址
  productShareUrl: 'https://tms.shupian.cn/#/',
  //生产单-分享对应的不同环境的地址
  kjscUrl: 'https://tggypapply.shupian.cn/',
  //会计管理
  applicationMainPcUrl: 'https://tbpmn.shupian.cn/#/apply/waitList',
  //应用主页-对应pc入口
  applicationMainAPPUrl: 'https://tmobie-bpmn.shupian.cn/#/pages/index/main',
  //应用主页-对应app入口
  mchDetailId: '1685429291604311049',
  // 商户ID
  fileUploadSecret: 'd80cad8d9e006267057e30365a49e336',
  //文件中心上传组件的secret
  kjscAuthUrl: 'https://tibosskjsc.dgg188.cn/' //会计生产-请求域名
};
// aBonW9gZFz0WgxHj-71V7r-PuP8AZfg1eZk0UcQ8wBI